import styled from 'styled-components'
import { INTER } from '@styles/fonts'
import { NEUTRAL_300 } from '@styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`

export const SectionLabel = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${NEUTRAL_300};
  padding: 0 16px;
  margin-top: 16px;
  margin-bottom: 16px;
`

export const PlanList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px 16px;
`

export const PlanWrapper = styled.div`
  cursor: pointer;
`

export const SearchBarWrapper = styled.div`
  padding: 16px 16px 0;
`

export const PhoneNumberList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px;
`

export const PhoneNumberWrapper = styled.div`
  cursor: pointer;
`

export const ButtonWrapper = styled.div`
  padding: 16px;
`
